import {
  MESSAGETEMPLATEDATA,
  TEMPLATEDATA,
  SETTITLEDATA,
  SETPHONEMESSAGEDATA,
  SETSMSMESSAGEDATA,
  SETEMAILMESSAGEDATA,
  SETLANGUAGEDATA,
  SETENGLISHPOSITIVERESPONSEDATA,
  SETENGLISHNEGATIVERESPONSEDATA,
  SETSPANISHPOSITIVERESPONSEDATA,
  SETSPANISHNEGATIVERESPONSEDATA,
  FETCH,
  FETCH2,
} from './actionType'
import axios from 'axios'
import tapConfig from '../../tapConfig'

export function messageTemplateData(data) {
  return {
    type: MESSAGETEMPLATEDATA,
    data: data,
  }
}
export function templateData(data) {
  return {
    type: TEMPLATEDATA,
    data: data,
  }
}
export function setTitleData(data) {
  return {
    type: SETTITLEDATA,
    data: data,
  }
}
export function setPhoneMessageData(data) {
  return {
    type: SETPHONEMESSAGEDATA,
    data: data,
  }
}
export function setSMSMessageData(data) {
  return {
    type: SETSMSMESSAGEDATA,
    data: data,
  }
}
export function setEmailMessageData(data) {
  return {
    type: SETEMAILMESSAGEDATA,
    data: data,
  }
}
export function setLanguageData(data) {
  return {
    type: SETLANGUAGEDATA,
    data: data,
  }
}
export function setEnglishPositiveResponseData(data) {
  return {
    type: SETENGLISHPOSITIVERESPONSEDATA,
    data: data,
  }
}
export function setEnglishNegativeResponseData(data) {
  return {
    type: SETENGLISHNEGATIVERESPONSEDATA,
    data: data,
  }
}
export function setSpanishPositiveResponseData(data) {
  return {
    type: SETSPANISHPOSITIVERESPONSEDATA,
    data: data,
  }
}
export function setSpanishNegativeResponseData(data) {
  return {
    type: SETSPANISHNEGATIVERESPONSEDATA,
    data: data,
  }
}

export function listMessageTemplateData(blossomID) {
  return function (dispatch) {
    tapConfig()
      .then((config) => {
        const apiKey = config.target_outreach_manager.apiKey
        dispatch(apiFetching(true))
        axios
          .get(
            config.target_outreach_manager.url +
              'target_emergency_alerts/v1/message_templates?key=' +
              encodeURIComponent(apiKey) +
              '&group_id=' +
              encodeURIComponent(blossomID),
          )
          .then(function (response) {
            if (response.data === null) {
              response.data = ''
            }
            dispatch(messageTemplateResponseData(response))
            dispatch(apiFetching(false))
          })
          .catch(function () {
            // removed error from function
            dispatch(apiFetching(false))
          })
      })
      .catch((error) => {
        console.error('Error fetching tapConfig:', error)
        dispatch(apiFetching(false))
      })
  }
}

export function addMessageTemplateEntry(
  blossomID,
  messageTitle,
  messageBodyPhone,
  messageBodySMS,
  messageBodyEmail,
  messageResponsePositive,
  messageResponseNegative,
  messageResponsePositiveEs,
  messageResponseNegativeEs,
  messageID,
) {
  return function (dispatch) {
    tapConfig()
      .then((config) => {
        const apiKey = config.target_outreach_manager.apiKey
        dispatch(apiFetching2(true))
        axios
          .post(
            config.target_outreach_manager.url +
              'target_emergency_alerts/v1/message_templates?key=' +
              encodeURIComponent(apiKey),
            {
              group_id: blossomID,
              message_title: messageTitle,
              message_body_phone: messageBodyPhone,
              message_body_sms: messageBodySMS,
              message_body_email: messageBodyEmail,
              message_response_positive: messageResponsePositive,
              message_response_negative: messageResponseNegative,
              message_response_positive_es: messageResponsePositiveEs,
              message_response_negative_es: messageResponseNegativeEs,
              pk_id: messageID,
            },
          )
          .then(function (response) {
            // Added below to get a pop up window when successful
            if (response.status === 201) {
              window.alert('Message Template Entry Successfully Added')
            } else {
              window.alert('Message Template Entry Not Successfully Added')
            }
            dispatch(listMessageTemplateData(blossomID))
            dispatch(apiFetching2(false))
          })
          .catch(function () {
            // removed error from function
            dispatch(apiFetching2(false))
          })
      })
      .catch((error) => {
        console.error('Error fetching tapConfig:', error)
        dispatch(apiFetching2(false))
      })
  }
}

export function removeMessageTemplateEntry(blossomID, messageID) {
  return function (dispatch) {
    tapConfig()
      .then((config) => {
        const apiKey = config.target_outreach_manager.apiKey
        dispatch(apiFetching2(true))
        axios
          .delete(
            config.target_outreach_manager.url +
              'target_emergency_alerts/v1/message_templates?key=' +
              encodeURIComponent(apiKey) +
              '&group_id=' +
              encodeURIComponent(blossomID) +
              '&pk_id=' +
              encodeURIComponent(messageID),
          )
          .then(function (response) {
            // Added below to get a pop up window when successful
            if (response.status === 204) {
              window.alert('Message Template Entry Successfully Deleted')
            } else {
              window.alert('Message Template Entry Not Successfully Deleted')
            }
            dispatch(listMessageTemplateData(blossomID))
            dispatch(apiFetching2(false))
          })
          .catch(function () {
            // removed error from function
            dispatch(apiFetching2(false))
          })
      })
      .catch((error) => {
        console.error('Error fetching tapConfig:', error)
        dispatch(apiFetching2(false))
      })
  }
}

function messageTemplateResponseData(response) {
  return {
    type: MESSAGETEMPLATEDATA,
    data: response.data,
  }
}

function apiFetching(status) {
  return {
    type: FETCH,
    fetching: status,
  }
}

function apiFetching2(status) {
  return {
    type: FETCH2,
    fetching: status,
  }
}
